
import React from 'react';
import Layout from '@/components/layout/Layout';
import { useGetSuppliers } from '@/hooks/use-supplier';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Loader2, Plus, AlertCircle, BarChart3 } from 'lucide-react';
import SupplierList from '@/components/suppliers/SupplierList';
import SupplierPerformanceReport from '@/components/reports/SupplierPerformanceReport';

const Suppliers = () => {
  const { data: suppliers, isLoading, error } = useGetSuppliers();

  return (
    <Layout>
      <div className="h-full">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">Suppliers</h1>
          <Button asChild>
            <Link to="/suppliers/new">
              <Plus className="mr-2 h-4 w-4" />
              Add Supplier
            </Link>
          </Button>
        </div>

        <Tabs defaultValue="list" className="space-y-4">
          <TabsList>
            <TabsTrigger value="list">Supplier List</TabsTrigger>
            <TabsTrigger value="performance">
              <BarChart3 className="h-4 w-4 mr-2" />
              Performance Report
            </TabsTrigger>
          </TabsList>

          <TabsContent value="list">
            {isLoading ? (
              <Card>
                <CardContent className="flex justify-center items-center py-8">
                  <Loader2 className="h-8 w-8 animate-spin text-primary" />
                </CardContent>
              </Card>
            ) : error ? (
              <Card>
                <CardContent className="flex flex-col items-center py-8 gap-2">
                  <AlertCircle className="h-8 w-8 text-destructive" />
                  <p>Failed to load suppliers</p>
                </CardContent>
              </Card>
            ) : (
              <SupplierList suppliers={suppliers || []} />
            )}
          </TabsContent>

          <TabsContent value="performance">
            <SupplierPerformanceReport />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
};

export default Suppliers;
